import DatabaseModel from './DatabaseModel.js';

var Rol = Object.create(DatabaseModel);

Rol.model = 'combos/roles';

export default Rol;